import { computed, Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingCount = signal(0);
  readonly loading = computed(() => this.loadingCount() > 0);

  // We keep a loading count to determine we are still loading data or not, because theoretically multiple
  // components/services/resolvers could be loading data at the same time, and we only want to initial loading events
  // if we were not loading anything prior (count = 0) and only end if we are now done (count = 0)
  start() {
    this.loadingCount.update(c => c + 1);
  }

  finish() {
    this.loadingCount.update(c => Math.max(c - 1, 0));
  }
}
